<template>
  <div>
    <section class="content">
      <div class="col-xs-12 accessory-search-form">
        <div class="search-form">
          <div class="input-group">
            <input
              type="text"
              name="search"
              v-model="searchKey"
              class="form-control accessory-search-input"
              placeholder="Search Accessory ID or Device ID..."
              id="search-plugin"
            >
            <div class="input-group-btn">
              <button
                class="btn btn-info btn-flat accessory-search-btn"
                v-on:click="toSearchPlugin"
              >
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
          <!-- /.input-group -->
        </div>
      </div>

      <!--default img-->
      <div class="accessory-list-default" v-show="isShowDefault">
        <img
          src="../../../static/img/icon_accessory_default.svg"
          class="center-block accessory-list-default-img"
        >
        <div class="text-center col-sm-6 col-sm-offset-3">
          <h4 class="page-404-tips">Find your accessory and its binding device.</h4>
        </div>
      </div>
      <!-- / default img-->
      <!--accessory list-->
      <div>
        <!--no matching result-->
        <div class="accessory-list-default" v-show="isShowEmptyList">
          <img
            src="../../../static/img/icon_no_matching_result.svg"
            class="center-block accessory-list-no-matching-img"
          >
          <div class="text-center col-sm-6 col-sm-offset-3">
            <h4 class="page-404-tips">Sorry, no matching results.</h4>
          </div>
        </div>
        <!--no matching result-->
        <!--search result-->
        <div class="accessory-list-overall" v-for="(item,index) in pluginList">
          <div v-show="true">
            <div class="accessory-list-overall">
              <div class="col-xs-12 accessory-list-header">
                <img
                  v-if="!item[1][0].icon"
                  class="accessory-list-type"
                  src="../../../static/img/accessoryicon/icon_eventlist_others.svg"
                >
                <img class="accessory-list-type" :src="item[1][0].icon" v-else>
                <span v-if="!item[1][0].typeName" class="accessory-list-type-name">Accessory</span>
                <span class="accessory-list-type-name" v-else>{{item[1][0].typeName}}</span>
                <span class="pull-right accessory-list-type-name">
                  Accessory ID:&nbsp;&nbsp;
                  <span>{{item[0]}}</span>
                </span>
              </div>
              <div class="col-xs-12 accessory-list-body" v-for="(pluginItem,pIndex) in item[1]">
                <div
                  class="accessory-list-rect row"
                  data-toggle="modal"
                  @click="toSetPlugin(index,pIndex)"
                >
                  <div class="col-xs-12 col-md-11 accessory-list-information">
                    <h5>
                      Accessory Name:&nbsp;&nbsp;
                      <span>{{pluginItem.isprepluginname}}</span>
                    </h5>
                    <h5>
                      Binding Device:&nbsp;&nbsp;
                      <span>{{pluginItem.devicename}}</span>
                      <span class="accessory-list-device-id">
                        (
                        <span>{{pluginItem.deviceid}}</span> )
                      </span>
                    </h5>
                  </div>

                  <div>
                    <i class="fa fa-chevron-right accessory-list-right-edit"></i>
                  </div>
                </div>
                <i class="fa fa-circle accessory-list-label"></i>
              </div>
            </div>
          </div>
        </div>
        <!--search result-->
      </div>
      <!-- /accessory list-->
    </section>

    <!-- add Accessory -->
    <div class="add-app-bgcolor dropup">
      <button data-toggle="dropdown" class="add-app-btn">
        <span class="btn add-app">
          <i class="fa fa-plus"></i>
        </span>
      </button>
      <ul class="dropdown-menu pull-right add-btn-dropdown-menu">
        <li>
          <a
            class="add-agent-choose"
            data-toggle="modal"
            @click="toAddPlugin"
            data-target="#modal-add-offical-accessory"
          >Add Offical Accessory</a>
        </li>
        <li>
          <a
            class="add-agent-choose"
            data-toggle="modal"
            @click="toAddThirdPlugin"
            data-target="#modal-add-third-party-accessory"
          >Add Third Party Accessory</a>
        </li>
      </ul>
    </div>
    <!-- /add Accessory -->
    <!--add offical accessory dialog-->
    <div class="modal fade in" id="modal-add-offical-accessory">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">Add Offical Accessory</h4>
          </div>
          <div class="modal-body">
            <div class="form-horizontal">
              <div class="form-group">
                <label class="col-sm-3 control-label agent-edit-modal-name">Accessory ID</label>
                <div class="col-sm-9 agent-edit-modal-name">
                  <input
                    class="form-control"
                    placeholder="Input Accessory ID"
                    v-model="currentAddPlugin.pluginid"
                  >
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 agent-edit-modal-name control-label">Accessory Type</label>
                <div class="col-sm-9 agent-edit-modal-name">
                  <select class="form-control" v-model="currentAddPlugin.sub">
                    <option value="0B">Door/Window Sensor</option>
                    <option value="09">PIR Motion Sensor</option>
                    <option value="05">Smoke Sensor</option>
                    <option value="06">Vibration Sensor</option>
                    <option value="07">Emergency Button</option>
                    <option value="02">Remote Controller</option>
                    <option value="15">SmartPlugs</option>
                    <option value="14">Wireless Sirens</option>
                    <option value="1B">SmartPad</option>
                    <option value="0E">Water Sensor</option>
                    <option value="37">Key Tag</option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label agent-edit-modal-name">Binding Device ID</label>
                <div class="col-sm-9 agent-edit-modal-name">
                  <input
                    class="form-control"
                    placeholder="Input Device ID"
                    v-model="currentAddPlugin.deviceid"
                  >
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 agent-edit-modal-name control-label">Type</label>
                <div class="col-sm-9 agent-edit-modal-name">
                  <select class="form-control" v-model="currentAddPlugin.isPre">
                    <option value="true">Pre-paired Accessory</option>
                    <option value="false">Non Pre-paired Accessory</option>
                  </select>
                </div>
              </div>
              <!--预配配件生产批次-->
              <div class="form-group" v-if="currentAddPlugin.isPre === 'true'">
                <label
                  class="col-sm-3 control-label agent-edit-modal-name control-label"
                >Production Batch</label>
                <div class="col-sm-9 agent-edit-modal-name">
                  <input class="form-control" placeholder="Text" v-model="currentAddPlugin.batch">
                </div>
              </div>
              <!-- / 预配配件生产批次-->
              <!--普通配件显示以下-->
              <div class="form-group" v-else>
                <label
                  class="col-sm-3 control-label agent-edit-modal-name control-label"
                >Accessory Name</label>
                <div class="col-sm-9 agent-edit-modal-name">
                  <input
                    class="form-control"
                    placeholder="Name the Accessory"
                    v-model="currentAddPlugin.pluginname"
                  >
                </div>
              </div>
              <!-- /普通配件显示以下-->
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
              aria-label="Cancel"
            >Cancel</button>
            <button type="button" class="btn btn-info" @click="toSavePlugin">Save changes</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!--/ add offical accessory dialog-->
    <!--add third party accessory dialog-->
    <div class="modal fade in" id="modal-add-third-party-accessory">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">Add Third Party Accessory</h4>
          </div>
          <div class="modal-body">
            <form class="form-horizontal">
              <div class="form-group">
                <label class="col-sm-3 control-label agent-edit-modal-name">Accessory ID</label>
                <div class="col-sm-9 agent-edit-modal-name">
                  <input
                    class="form-control"
                    placeholder="Input Accessory ID"
                    v-model="currentAddPlugin.pluginid"
                  >
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 agent-edit-modal-name control-label">Accessory Type</label>
                <div class="col-sm-9 agent-edit-modal-name">
                  <select class="form-control" v-model="currentAddPlugin.sub">
                    <option value="0B">Door/Window Sensor</option>
                    <option value="09">PIR Motion Sensor</option>
                    <option value="05">Smoke Sensor</option>
                    <option value="07">Emergency Button</option>
                    <option value="02">Remote Controller</option>
                    <option value="14">Wireless Sirens</option>
                    <option value="1B">SmartPad</option>
                    <option value="0E">Water Sensor</option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label agent-edit-modal-name">Binding Device ID</label>
                <div class="col-sm-9 agent-edit-modal-name">
                  <input
                    class="form-control"
                    placeholder="Input Device ID"
                    v-model="currentAddPlugin.deviceid"
                  >
                </div>
              </div>
              <div class="form-group">
                <label
                  class="col-sm-3 control-label agent-edit-modal-name control-label"
                >Accessory Name</label>
                <div class="col-sm-9 agent-edit-modal-name">
                  <input
                    class="form-control"
                    placeholder="Name the Accessory"
                    v-model="currentAddPlugin.pluginname"
                  >
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
              aria-label="Cancel"
            >Cancel</button>
            <button type="button" class="btn btn-info" @click="toSaveThirdPlugin">Save changes</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!--/ add third party accessory dialog-->
    <!--set accessory dialog-->
    <div class="modal fade in" id="modal-set-ipc">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 v-if="!currentPlugin.typeName" class="modal-title">Set Accessory</h4>
            <h4 class="modal-title" v-else>Set {{currentPlugin.typeName}}</h4>
          </div>
          <div class="modal-body">
            <form class="form-horizontal">
              <div class="form-group modal-user-profile-head">
                <div class="modal-self-profile-upload-head modal-user-profile-head-input">
                  <input>
                </div>
                <img
                  v-if="!currentPlugin.icon"
                  class="modal-user-profile-img modal-user-profile-head-img"
                  src="../../../static/img/accessoryicon/icon_eventlist_others.svg"
                >
                <img
                  class="modal-user-profile-img modal-user-profile-head-img"
                  :src="currentPlugin.icon"
                  v-else
                >
                <h5>
                  Accessory ID:&nbsp;&nbsp;
                  <span>{{currentPlugin.pluginid}}</span>
                </h5>
              </div>

              <div class="form-group accessory-modal-set-binding-device">
                <label class="col-sm-12 control-label agent-edit-modal-name">
                  <i class="fa fa-desktop accessory-modal-set-title-desktop"></i>
                  Binding Device:&nbsp;&nbsp;
                  <p
                    class="accessory-modal-set-title-device set-accessory-dia-device-name"
                    v-on:click="toSearchDevice(currentPlugin.devicename, currentPlugin.deviceid)"
                    data-dismiss="modal"
                  >
                    {{currentPlugin.devicename}}
                    (
                    <span>{{currentPlugin.deviceid}}</span>)
                  </p>
                </label>
              </div>

              <!--information-->
              <div class="accessory-modal-set-data-group">
                <hr>
                <h5 class="accessory-modal-set-title">
                  <i class="fa fa-file-text-o accessory-modal-set-title-icon"></i>Information
                </h5>
                <div class="col-xs-4 accessory-modal-set-info">
                  <h5>
                    <label>Binding Time:&nbsp;&nbsp;</label>
                    {{currentPlugin.time / 1000000 | formatDate}}
                  </h5>
                </div>
                <div class="col-xs-8 accessory-modal-set-info">
                  <h5 class="pull-right">
                    <label>Type:</label>&nbsp;&nbsp;
                    <span v-if="currentPlugin.isFactory">Pre-paired Accessory</span>
                    <span v-else>Non Pre-paired Accessory</span>&nbsp;;&nbsp;
                    <span v-if="currentPlugin.cat != 20">Offical Accessory</span>
                    <span v-if="currentPlugin.cat == 20">Third Party Accessory</span>
                  </h5>
                </div>
                <div class="form-group">
                  <label
                    class="col-sm-3 control-label agent-edit-modal-name control-label"
                  >Accessory Name</label>
                  <div class="col-sm-9 agent-edit-modal-name">
                    <input
                      class="form-control"
                      placeholder="Name"
                      v-model="currentPlugin.pluginname"
                      v-if="!offlineClass"
                      disabled
                    >
                    <input
                      class="form-control"
                      placeholder="Name"
                      v-model="currentPlugin.pluginname"
                      v-else
                    >
                  </div>
                </div>
              </div>
              <!-- / information-->
              <!--setting-->
              <div class="accessory-modal-set-data-group" v-show="false">
                <!--<div class="accessory-modal-set-data-group" v-show="currentPlugin.typeName == 'Smart Plug' || currentPlugin.typeName == 'Wireless Siren'">-->
                <hr>
                <h5 class="accessory-modal-set-title">
                  <i class="fa fa-sliders accessory-modal-set-title-icon"></i>
                  Setting
                  <label
                    class="label accessory-modal-offline-lable"
                    v-show="!offlineClass"
                  >Device Offline</label>
                </h5>
                <!--set switch-->
                <div class="form-group" v-show="currentPlugin.typeName == 'Smart Plug'">
                  <label class="col-xs-10 control-label agent-edit-modal-name">Status:&nbsp;&nbsp;</label>
                  <div class="col-xs-2 modal-parameter-setting-switch">
                    <input
                      type="checkbox"
                      class="switch-checkbox pull-right"
                      checked="checked"
                      data-on-color="info"
                      data-off-color="warning"
                      v-if="offlineClass == true"
                    >
                    <input
                      type="checkbox"
                      class="switch-checkbox pull-right"
                      checked="checked"
                      data-on-color="info"
                      data-off-color="warning"
                      v-else
                      disabled
                    >
                  </div>
                </div>
                <!--set switch-->
                <!--set siren-->
                <div class="form-group" v-show="currentPlugin.typeName == 'Wireless Siren'">
                  <label>Prompt Tone:</label>
                  <div class="row">
                    <div class="col-xs-4">
                      Disarm
                      <input
                        type="checkbox"
                        class="switch-checkbox"
                        checked="checked"
                        data-on-color="info"
                        data-off-color="warning"
                        v-if="offlineClass == true"
                      >
                      <input
                        type="checkbox"
                        class="switch-checkbox"
                        checked="checked"
                        data-on-color="info"
                        data-off-color="warning"
                        v-else
                        disabled
                      >
                    </div>
                    <div class="col-xs-4">
                      <div class="pull-v">
                        Home Arm
                        <input
                          type="checkbox"
                          class="switch-checkbox"
                          checked="checked"
                          data-on-color="info"
                          data-off-color="warning"
                          v-if="offlineClass == true"
                        >
                        <input
                          type="checkbox"
                          class="switch-checkbox"
                          checked="checked"
                          data-on-color="info"
                          data-off-color="warning"
                          v-else
                          disabled
                        >
                      </div>
                    </div>
                    <div class="col-xs-4">
                      <div class="pull-right">
                        Arm
                        <input
                          type="checkbox"
                          class="switch-checkbox"
                          checked="checked"
                          data-on-color="info"
                          data-off-color="warning"
                          v-if="offlineClass == true"
                        >
                        <input
                          type="checkbox"
                          class="switch-checkbox"
                          checked="checked"
                          data-on-color="info"
                          data-off-color="warning"
                          v-else
                          disabled
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <!--小警笛没有灯光设置-->
                <div class="form-group">
                  <label>Light Mode:</label>
                  <div class="row">
                    <div class="col-xs-6">
                      Disarm
                      <select
                        class="accessory-modal-set-selection"
                        v-if="offlineClass == true"
                      >
                        <option>OFF</option>
                        <option>Always</option>
                        <option>Twinkle</option>
                        <option>Flash</option>
                      </select>
                      <select class="accessory-modal-set-selection-offline" v-else disabled>
                        <option>OFF</option>
                        <option>Always</option>
                        <option>Twinkle</option>
                        <option>Flash</option>
                      </select>
                    </div>
                    <div class="col-xs-6">
                      <div class="pull-right">
                        Home Arm
                        <select
                          class="accessory-modal-set-selection"
                          v-if="offlineClass == true"
                        >
                          <option>OFF</option>
                          <option>Always</option>
                          <option>Twinkle</option>
                          <option>Flash</option>
                        </select>
                        <select class="accessory-modal-set-selection-offline" v-else disabled>
                          <option>OFF</option>
                          <option>Always</option>
                          <option>Twinkle</option>
                          <option>Flash</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="row accessory-modal-set-siren-row">
                    <div class="col-xs-6">
                      Arm
                      <select class="accessory-modal-set-selection" v-if="offlineClass == true">
                        <option>OFF</option>
                        <option>Always</option>
                        <option>Twinkle</option>
                        <option>Flash</option>
                      </select>
                      <select class="accessory-modal-set-selection-offline" v-else disabled>
                        <option>OFF</option>
                        <option>Always</option>
                        <option>Twinkle</option>
                        <option>Flash</option>
                      </select>
                    </div>
                    <div class="col-xs-6">
                      <div class="pull-right">
                        Alarm
                        <select
                          class="accessory-modal-set-selection"
                          v-if="offlineClass == true"
                        >
                          <option>OFF</option>
                          <option>Always</option>
                          <option>Twinkle</option>
                          <option>Flash</option>
                        </select>
                        <select class="accessory-modal-set-selection-offline" v-else disabled>
                          <option>OFF</option>
                          <option>Always</option>
                          <option>Twinkle</option>
                          <option>Flash</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- / 小警笛没有灯光设置-->
                <div class="form-group">
                  <label>Volume:</label>
                  <div class="row">
                    <div class="col-xs-6">
                      Prompt Tone
                      <select
                        class="accessory-modal-set-selection"
                        v-if="offlineClass == true"
                      >
                        <option>10</option>
                        <option>9</option>
                        <option>8</option>
                        <option>7</option>
                        <option>6</option>
                        <option>5</option>
                        <option>4</option>
                        <option>3</option>
                        <option>2</option>
                        <option>1</option>
                        <option>0</option>
                      </select>
                      <select class="accessory-modal-set-selection-offline" v-else disabled>
                        <option>10</option>
                        <option>9</option>
                        <option>8</option>
                        <option>7</option>
                        <option>6</option>
                        <option>5</option>
                        <option>4</option>
                        <option>3</option>
                        <option>2</option>
                        <option>1</option>
                        <option>0</option>
                      </select>
                    </div>
                    <div class="col-xs-6">
                      <div class="pull-right">
                        Alarm
                        <select
                          class="accessory-modal-set-selection"
                          v-if="offlineClass == true"
                        >
                          <option>10</option>
                          <option>9</option>
                          <option>8</option>
                          <option>7</option>
                          <option>6</option>
                          <option>5</option>
                          <option>4</option>
                          <option>3</option>
                          <option>2</option>
                          <option>1</option>
                          <option>0</option>
                        </select>
                        <select class="accessory-modal-set-selection-offline" v-else disabled>
                          <option>10</option>
                          <option>9</option>
                          <option>8</option>
                          <option>7</option>
                          <option>6</option>
                          <option>5</option>
                          <option>4</option>
                          <option>3</option>
                          <option>2</option>
                          <option>1</option>
                          <option>0</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label>Siren Time (Min)</label>
                  <select class="accessory-modal-set-selection" v-if="offlineClass == true">
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                  </select>
                  <select class="accessory-modal-set-selection-offline" v-else disabled>
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                  </select>
                </div>
                <!-- / set siren-->
              </div>
              <!-- / setting-->
            </form>
          </div>
          <div class="modal-footer dropup">
            <button
              type="button"
              class="btn btn-default pull-left"
              data-toggle="dropdown"
              v-if="offlineClass == true"
            >Unbind Device</button>
            <button
              type="button"
              class="btn btn-default pull-left"
              disabled="disabled"
              v-else
            >Unbind Device</button>
            <ul class="dropdown-menu pull-left alert-del accessory-list-alert">
              <li>
                <i class="icon fa fa-warning alert-del-warning"></i>Confirm to unbind?
              </li>
              <li>
                <button class="btn btn-default">Cancel</button>
                <button class="btn btn-danger" @click="toUnbindPlugin">Unbind</button>
              </li>
            </ul>
            <button type="button" class="btn btn-info" @click="toChangePluginName">Save changes</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- / set accessory dialog-->
  </div>
</template>

<script>

import api from '../../api'
import utils from '../../utils'
import global from '../Global.vue'
import config from '../../config'

export default {
  name: 'Accessory',
  data () {
    return {
      searchKey: '',
      plugins: [],
      pluginList: [],
      isShowDefault: true,
      isShowEmptyList: false,
      currentPlugin: {},
      currentAddPlugin: {},
      offlineClass: false,
      dataS: {}
    }
  },
  mounted: function () {
    var that = this
    if (this.$route.query.online === '1') {
      this.offlineClass = true
    } else {
      this.offlineClass = false
    }
    this.searchKey = this.$route.query.key
    this.toSearchPlugin()
    //      window.jQuery('[data-toggle="hideseek"]').off().hideseek()
    window.jQuery('#search-plugin').keydown(function (event) {
      if (event.which === 13) {
        that.toSearchPlugin()
      }
    })
  },
  methods: {
    toSearchPlugin () {
      if (utils.isEmpty(this.searchKey)) {
        return
      }
      //        var that = this
      var params = new URLSearchParams()
      var jsons = {
        appid: this.$route.query.appid,
        pluginname: this.searchKey
      }
      params.append('json', utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET))
      if (window.localStorage) {
        params.append('token', window.localStorage.getItem('token'))
      }
      this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
      api.request('post', '/searchplugin?_type=json', params)
        .then(response => {
          this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
          var data = response.data
          if (data.Status !== 1) {
            this.isShowEmptyList = true
            this.isShowDefault = false
            var errorName = data.ErrorMessage
            if (errorName) {
              utils.showMsg(errorName)
            } else {
              utils.showMsg('search fail')
            }
            return
          } else {
            this.pluginList = []
            this.plugins = JSON.parse(utils.getDecodeRC4Hex(data.Result, global.APP_SECRET))
            var p = new Map()
            for (var i = 0; i < this.plugins.length; i++) {
              if (this.plugins[i].pluginname === '') {
                this.plugins[i].isprepluginname = '( Pre-paired Accessory )'
              } else {
                this.plugins[i].isprepluginname = this.plugins[i].pluginname
              }
              this.plugins[i].typeName = utils.getNameByCatAndSub(this.plugins[i].cat, this.plugins[i].sub)
              this.plugins[i].icon = utils.getPluginIconByCatAndSub(this.plugins[i].cat, this.plugins[i].sub)
              if (p.has(this.plugins[i].pluginid)) {
                p.get(this.plugins[i].pluginid).push(this.plugins[i])
              } else {
                var plugin = []
                plugin.push(this.plugins[i])
                p.set(this.plugins[i].pluginid, plugin)
              }
            }
            this.pluginList = Array.from(p)
            utils.log(this.pluginList)
            if (this.pluginList.length <= 0) {
              this.isShowEmptyList = true
              this.isShowDefault = false
            } else {
              this.isShowEmptyList = false
              this.isShowDefault = false
            }
          }
        })
    },
    toSetPlugin (i, k) {
      this.currentPlugin = this.pluginList[i][1][k]
      var params = new URLSearchParams()
      var jsons = {
        appid: this.$route.query.appid,
        deviceid: this.currentPlugin.deviceid,
        pluginid: this.currentPlugin.pluginid,
        type: this.currentPlugin.cat,
        stype: this.currentPlugin.sub,
        sid: this.currentPlugin.sid
      }
      params.append('json', utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET))
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token)
      }
      this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
      api.requestWithServerUrl('post', config.serverURI, '/checkfactoryplugins?_type=json', params)
        .then(response => {
          var data = response.data
          if (data.Status !== 1) {
          } else {
            this.currentPlugin.isFactory = utils.getDecodeRC4Hex(data.Result, global.APP_SECRET) === 'true'
            this.toJudgeDeviceState()
          }
        })
    },
    toJudgeDeviceState () {
      var params2 = new URLSearchParams()
      var jsons2 = {
        appid: this.$route.query.appid,
        deviceid: this.currentPlugin.deviceid
      }
      params2.append('json', utils.getRC4Hex(JSON.stringify(jsons2), global.APP_SECRET))
      if (window.localStorage) {
        params2.append('token', this.$router.app.$store.state.user.token)
      }
      api.requestWithServerUrl('post', config.serverURI, '/getdevicestate?_type=json', params2)
        .then(response => {
          this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
          var data = response.data
          if (data.Status !== 1) {
          } else {
            var temp = JSON.parse(utils.getDecodeRC4Hex(data.Result, global.APP_SECRET))
            this.offlineClass = temp.online
            window.jQuery('#modal-set-ipc').modal('show')
          }
        })
    },
    toUnbindPlugin () {
      var jsons = {}
      if (this.currentPlugin.cat === 10) {
        jsons = {
          messageid: utils.getMessageId(),
          devtoken: this.currentPlugin.devicetoken,
          cmd: 'DELETE_NEWASKPLUGIN',
          stype: this.currentPlugin.sub,
          sendid: this.currentPlugin.pluginid,
          userid: ''
        }
      } else {
        jsons = {
          messageid: utils.getMessageId(),
          devtoken: this.currentPlugin.devicetoken,
          cmd: 'DELETE_PLUGIN',
          category: this.currentPlugin.cat,
          pluginid: this.currentPlugin.pluginid,
          userid: ''
        }
      }
      var params = new URLSearchParams()

      params.append('json', JSON.stringify(jsons))
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token)
      }
      api.requestWithServerUrl('post', config.blackholeServerURI, '/device/sendcmd/' + this.$route.query.appid, params)
        .then(response => {
          var data = response.data
          if (data.Status !== 1) {
          } else {
            for (var i = 0; i < this.pluginList.length; i++) {
              for (var j = 0; j < this.pluginList[i][1].length; j++) {
                if (this.pluginList[i][1][j].deviceid === this.currentPlugin.deviceid && this.pluginList[i][1][j].pluginid === this.currentPlugin.pluginid) {
                  this.pluginList[i][1].splice(j, 1)
                  if (this.pluginList[i][1].length <= 0) {
                    this.pluginList.splice(i, 1)
                    if (this.pluginList.length <= 0) {
                      this.isShowEmptyList = true
                      this.isShowDefault = false
                    } else {
                      this.isShowEmptyList = false
                      this.isShowDefault = false
                    }
                  }
                  break
                }
              }
            }

            window.jQuery('#modal-set-ipc').modal('hide')
          }
        })
    },
    toChangePluginName () {
      var jsons = {}
      if (this.currentPlugin.cat === 10) {
        jsons = {
          messageid: utils.getMessageId(),
          devtoken: this.currentPlugin.devicetoken,
          cmd: 'SET_NEWASKPLUGINDATA',
          stype: this.currentPlugin.sub,
          sendid: this.currentPlugin.pluginid,
          name: this.currentPlugin.pluginname
        }
      } else {
        jsons = {
          messageid: utils.getMessageId(),
          devtoken: this.currentPlugin.devicetoken,
          cmd: 'SET_PLUGINDATA',
          category: this.currentPlugin.cat,
          pluginid: this.currentPlugin.pluginid,
          plugin_item_name: this.currentPlugin.pluginname
        }
      }
      var params = new URLSearchParams()

      params.append('json', JSON.stringify(jsons))
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token)
      }
      api.requestWithServerUrl('post', config.blackholeServerURI, '/device/sendcmd/' + this.$route.query.appid, params)
        .then(response => {
          var data = response.data
          if (data.Status !== 1) {
          } else {
            for (var i = 0; i < this.pluginList.length; i++) {
              for (var j = 0; j < this.pluginList[i][1].length; j++) {
                if (this.pluginList[i][1][j].deviceid === this.currentPlugin.deviceid && this.pluginList[i][1][j].pluginid === this.currentPlugin.pluginid) {
                  this.pluginList[i][1][j].pluginname = this.currentPlugin.pluginname
                  break
                }
              }
            }
            window.jQuery('#modal-set-ipc').modal('hide')
          }
        })
    },
    toAddThirdPlugin () {
      this.currentAddPlugin = { sub: '0B' }
    },
    toAddPlugin () {
      this.currentAddPlugin = { sub: '0B', isPre: 'false' }
    },
    toSavePlugin () {
      if (this.currentAddPlugin.isPre === 'true') {
        this.toAddPrePlugin()
      } else {
        this.toAddNoPrePlugin()
      }
    },
    toAddNoPrePlugin () {
      var jsons = {}
      jsons = {
        messageid: utils.getMessageId(),
        deviceid: this.currentAddPlugin.deviceid,
        cmd: 'ADD_PLUGIN',
        category: utils.getCategory(this.currentAddPlugin.sub),
        pluginid: this.currentAddPlugin.pluginid,
        subcategory: this.currentAddPlugin.sub,
        pluginname: this.currentAddPlugin.pluginname
      }
      var params = new URLSearchParams()
      params.append('json', JSON.stringify(jsons))
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token)
      }
      api.requestWithServerUrl('post', config.blackholeServerURI, '/device/sendcmdadmin/' + this.$route.query.appid, params)
        .then(response => {
          var data = response.data
          if (data.Status !== 1) {
          } else {
            window.jQuery('#modal-add-offical-accessory').modal('hide')
          }
        })
    },
    toAddPrePlugin () {
      var jsons = {}
      jsons = {
        deviceid: this.currentAddPlugin.deviceid,
        pluginids: this.currentAddPlugin.pluginid,
        batch: this.currentAddPlugin.batch
      }
      var params = new URLSearchParams()
      params.append('json', JSON.stringify(jsons))
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token)
      }
      api.requestWithServerUrl('post', config.blackholeServerURI, '/device/addfactorypluginlist/' + this.$route.query.appid, params)
        .then(response => {
          var data = response.data
          if (data.Status !== 1) {
          } else {
            window.jQuery('#modal-add-offical-accessory').modal('hide')
          }
        })
    },
    toSaveThirdPlugin () {
      var jsons = {}
      jsons = {
        messageid: utils.getMessageId(),
        deviceid: this.currentAddPlugin.deviceid,
        cmd: 'ADD_PLUGIN',
        category: 20,
        pluginid: this.currentAddPlugin.pluginid.substring(0, 4),
        decodeid: this.currentAddPlugin.pluginid,
        subcategory: this.currentAddPlugin.sub,
        pluginname: this.currentAddPlugin.pluginname
      }
      var params = new URLSearchParams()
      params.append('json', JSON.stringify(jsons))
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token)
      }
      api.requestWithServerUrl('post', config.blackholeServerURI, '/device/sendcmdadmin/' + this.$route.query.appid, params)
        .then(response => {
          var data = response.data
          if (data.Status !== 1) {
          } else {
            window.jQuery('#modal-add-third-party-accessory').modal('hide')
          }
        })
    },
    toSearchDevice (devicename, deviceid) {
      this.$router.push('/aboutdevice?appid=' + this.$route.query.appid +
        '&appname=' + this.$route.query.appname +
        '&deviceid=' + deviceid + '&devicename=' + devicename + '&online=' + this.offlineClass + '&t=' + this.$store.state.devicetoken)
    }
  },
  filters: {
    formatDate (time) {
      var date = new Date(time)
      return utils.formatDate(date, 'yyyy-MM-dd')
    }
  }
}
</script>

<style>
.skin-purple .wrapper {
  background-color: #ecf0f5;
}
</style>



// WEBPACK FOOTER //
// Accessory.vue?7ab2b582